module.exports = __webpack_public_path__ + "img/bootstrap4-light-blue.0bb2d9fc.svg";